import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const LetterWrap = styled.div`
  margin-bottom: 240px;
  ${customMedia.lessThan('tablet_cut_line')`
    margin-bottom: 124px;
`}
`

const LetterTab = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLOR.blueGray2};
`
const LetterTabItem = styled.p`
  font-family: NotoSansMedium, sans-serif;
  font-size: 16px;
  line-height: 23px;
  color: ${(props) => props.color};
  border-bottom: ${(props) => props.color === COLOR.black && '1px solid black'};
  margin: 0;
  padding: 8px 8px 9px 8px;
  cursor: pointer;
  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    line-height:20px;
`}
`

const LetterItemsList = styled.div`
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  ${customMedia.lessThan('tablet')`
    margin-top: 25px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    gap: 20px;
`}
`

const LetterItems = styled.section`
  width: 356px;
  border-radius: 20px;
  display: block;
  cursor: pointer;

  > img {
    display: flex;
    width: 356px;
    height: 267px;
    border-radius: 20px;
  }

  > p {
    width: 356px;
    white-space: pre-wrap;
    font-family: NotoSansBold, sans-serif;
    margin: 20px 0 36px 0;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${customMedia.lessThan('tablet')`
    width: 292px;
    margin: 0 auto;
    > img{
        width: 292px;
        height: 219px;
    }
    >p{
        margin: 8px 0 8px 0;
        width: 292px;
        font-size: 14px;
        line-height: 20px;
    }
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    width: 328px;
    > img{
        width: 328px;
        height: 246px;
    }
    >p{
        margin: 8px 0 8px 0;
        width: 328px;
        font-size: 14px;
        line-height: 20px;
    }
   `}
`

const LetterDetailWrap = styled.div`
  margin: 32px auto 0 auto;

  ${customMedia.lessThan('tablet')`
    margin-top: 24px;
    display: block;
   `}
  > div {
    margin: 0 auto 36px auto;
    max-width: 800px;
    width: 100%;
    border-bottom: 1px solid ${COLOR.blueGray2};

    > p {
      max-width: 800px !important;
      padding: 0;
      margin: 0 auto 28px auto;

      ${customMedia.lessThan('tablet')`
        max-width: 600px;
        width : 100%;
        margin 0 auto 24px auto;
    `}
    }

    > div {
      > p {
        margin: 0 auto 48px auto;
        max-width: 800px !important;
        width: 100%;
        * {
          max-width: 800px !important;
          width: 100%;
          margin: 0 auto !important;
        }
        ${customMedia.lessThan('tablet')`
          max-width: 600px !important;
          width : 100%;
          margin 0 auto 40px auto;
          * {
            max-width: 600px !important;
            width: 100%;
            margin: 0 auto !important;
          }
         `}
        ${customMedia.lessThan('tablet_cut_line')`
          max-width: 328px !important;
          width : 100%;
          * {
            max-width: 328px !important;
            width: 100%;
          }
        `}
      }
    }
  }
`
const LetterDetailNextConts = styled.section`
  width: 1100px;
  height: 310px;
  display: flex;
  gap: 16px;

  > h3 {
    margin: 46px 0 24px 0;
    text-align: center;
    font-size: 20px;
    line-height: 29px;
    font-family: NotoSansBold, sans-serif;
  }

  ${customMedia.lessThan('tablet')`
    width:328px;
    display: block;
    margin: 0 auto;
    height: unset;
  `}
  > div {
    cursor: pointer;
    border-radius: 20px;
    display: block;

    > img {
      display: flex;
      border-radius: 20px;
      width: 356px;
      height: 267px;
      ${customMedia.lessThan('tablet')`
        width:328px;
        height: 246px;
     `}
    }

    > p {
      max-width: 340px;
      width: 100%;
      white-space: pre-wrap;
      margin: 20px auto 0 auto;
      font-family: NotoSansBold, sans-serif;
      font-size: 16px;
      line-height: 23px;
      ${customMedia.lessThan('tablet')`
        margin: 8px auto 20px auto;
     `}
    }
  }
`
export {
  LetterDetailNextConts,
  LetterDetailWrap,
  LetterItems,
  LetterItemsList,
  LetterTab,
  LetterTabItem,
  LetterWrap,
}
